<form [formGroup]="userForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Сброс пароля</h3>
  <div mat-dialog-content>
    <mat-form-field appearance="standard">
      <mat-label>Новый пароль</mat-label>
      <input matInput formControlName="password" placeholder="Введите новый пароль"
             [type]="passwordHide ? 'password' : 'text'"
             cdkFocusInitial
             required="required">
      <button mat-icon-button matSuffix
              type="button"
              [matTooltip]="passwordHide ? 'Отобразить пароль' : 'Скрыть пароль'"
              [attr.aria-pressed]="passwordHide"
              (click)="passwordHide = !passwordHide">
        <mat-icon>{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Сбросить
    </button>
  </div>
</form>
